import { useNavigate, useParams } from "react-router-dom";
import cx from "classnames";
import TimeAgo from "react-timeago";
import _ from "lodash";

import UserIcon from "../userIcon";

import styles from "./styles.module.scss";
import { DealRoomEngageChatUser } from "src/types/dealRoom";

interface UserDetails {
  user: DealRoomEngageChatUser;
  showHighlights: boolean;
}

const UserDetails: React.FC<UserDetails> = ({ user, showHighlights = true }) => {
  const navigate = useNavigate();
  const { id, conversationId } = useParams();
  const firstName = _.get(user, 'firstName', '');
  const lastName = _.get(user, 'lastName', '');
  const userId = _.get(user, 'id', '');

  const isUserOnline = _.get(user, 'online', false);
  const isCurrentUser = conversationId ? `${userId}` === `${conversationId}` : false;

  const getLastActiveTime = (chatUser: DealRoomEngageChatUser) => {
    if (chatUser?.lastOnline === null) {
      return 'offline';
    }
    return (<TimeAgo date={_.get(chatUser, 'lastOnline', 0)} live={false} />)
  }

  return (
    <div
      className={cx(styles.container, {
        [styles.activeContainer]: showHighlights && isCurrentUser,
        [styles.border]: showHighlights,
      })}
      onClick={() => navigate(`/deal-room/${id}/engage/${userId}`)}>
      <UserIcon isOnline={isUserOnline} imageSrc={_.get(user, 'contactDTO.icon.thumbnail', '')} />

      <div className={styles.rightContainer}>
        <p style={{ maxWidth: '' }} className={cx(styles.userName, styles.truncatedText, {
          [styles.active]: showHighlights && isCurrentUser,
        })}>{`${firstName ?? ''} ${lastName ?? ''}`}</p>

        <p className={styles.activityStatus}>{isUserOnline ? 'active now' : getLastActiveTime(user)}</p>
      </div>
    </div>
  )
}

export const PlaceholderUserDetails = () => {
  return (
    <div className={styles.container}>
      <div className={cx(styles.icon, styles.block)}></div>

      <div className={styles.rightContainer}>
        <div className={cx(styles.userNameLoader, styles.block)}>{" "}</div>
        <div className={cx(styles.activityStatusLoader, styles.block)}>{" "}</div>
      </div>
    </div>
  )
}

export default UserDetails;